import React, { Suspense, useState } from "react";
import "../Login/Login.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { BeatLoader } from "react-spinners";
import Header from "../../DefaultLayout/Header";
import Footer from "../../DefaultLayout/Footer";
import Loading from "../../components/Loading";
import { userLogin, loadUser } from "../../actions/authActions";
import { toast } from "react-toastify";
import { Link,  Redirect,  useHistory, } from "react-router-dom";
import { Button, Form, FormGroup, Input } from "reactstrap";
import { connect } from "react-redux";
import {
  checkEmailValidation,
  checkRequiredValidationWithMinMax,

} from "../../Helpers/Validation";
import DashboardNavbar from "../../DefaultLayout/DashboardNavbar";
import { FaEye, FaEyeSlash } from 'react-icons/fa'; 
import { useDispatch } from "react-redux";

function Login(props) {
 
  const { auth, label } = props;
    const dispatch = useDispatch();
   const history = useHistory()
  const { frontLabelsName } = label;
  const { isAuthenticated, loading,user } = auth;

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error_Email, set_Error_Email] = useState("");
  const [error_Password, set_Error_Password] = useState("");
  const [loader, setLoading] = useState(false);

  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    let errEmail = null;
    let errPassword = null;
    let validationFlag = true;

    errEmail = checkEmailValidation(email, "lbl_email");
    errPassword = checkRequiredValidationWithMinMax(password, "lbl_password",6,15);

    if (errEmail || errPassword) {
      validationFlag = false;
      set_Error_Email(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == errEmail).length > 0
            ? frontLabelsName.filter((e) => e.key == errEmail)[0]["value"] ||
            errEmail
            : errEmail
          : errEmail
      );
      set_Error_Password(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == errPassword).length > 0
            ? frontLabelsName.filter((e) => e.key == errPassword)[0]["value"] ||
            errPassword
            : errPassword
          : errPassword
      );
    } else {
      validationFlag = true;
      set_Error_Email("");
      set_Error_Password("");
    }
    if (validationFlag) {
      setLoading(true);
  
  
      const userObj = {
        email,
        password,
      };

      props
        .userLogin(userObj)
        .then((res) => {
          setLoading(false);
       
          toast.success(
            frontLabelsName
              ? frontLabelsName.filter((e) => e.key == res.data.message).length > 0
                ? frontLabelsName.filter((e) => e.key == res.data.message)[0][
                "value"
                ] || res.data.message
                : res.data.message
              : res.data.message
          );
         
        })
        .catch((err) => {
          setLoading(false);
          toast.error(
            frontLabelsName
              ? frontLabelsName.filter((e) => e.key == err.response.data.message)
                .length > 0
                ? frontLabelsName.filter(
                  (e) => e.key == err.response.data.message
                )[0]["value"] || err.response.data.message
                : err.response.data.message
              : err.response.data.message
          );
        });
    }
  };

  if (isAuthenticated && !loading) {

 if(user?.isRegistrationCompleted){
  localStorage.removeItem("isSubscribing")
  dispatch({
    type:"SET_STEP",
    payload:{step:0,status:false}
 });
  return <Redirect to={ "/dashboard" } />;
 }else if(user?.isSubscribing){
  dispatch({
    type: "SET_IS_SUBSCRIBING",
    payload: { isSubscribing: true },
  });
localStorage.setItem("isSubscribing",true)
  dispatch({
    type:"SET_STEP",
    payload:{step:0,status:true}
 });
 localStorage.setItem("currentStepIndex", 0)
  history.push('/terms-and-condition')
 }else{
  dispatch({
    type: "SET_IS_SUBSCRIBING",
    payload: { isSubscribing: false },
  });
localStorage.setItem("isSubscribing",false)

  dispatch({
    type:"SET_STEP",
    payload:{step:0,status:true}
 });
 localStorage.setItem("currentStepIndex", 0)
  history.push('/terms-and-condition') 
 }
   
  }

  return (
    <React.Fragment>
      <Suspense fallback={<Loading />}>
        <Header />
        {/* <NavbarSection /> */}
        <DashboardNavbar/>
      </Suspense>
      <div className="main-login">
        <div className="login-box">
          <Form>
            <div className="text-center">
              <h2 className="set-font-size">
                {frontLabelsName
                  ? frontLabelsName.filter((e) => e.key == "lbl_login").length > 0
                    ? frontLabelsName.filter((e) => e.key == "lbl_login")[0][
                    "value"
                    ] || "lbl_login"
                    : "lbl_login"
                  : "lbl_login"}
              </h2>
            </div>
            <div className="set-pdd">
              <div className="set-width-dd">
                <FormGroup className="set-bg-feild">
                  <Input
                    type="email"
                    name="email"
                    placeholder={
                      frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_email")
                          .length > 0
                          ? frontLabelsName.filter((e) => e.key == "lbl_email")[0][
                          "value"
                          ] || "lbl_email"
                          : "lbl_email"
                        : "lbl_email"
                    }
                    errorValue={error_Email}
                    onChange={(e) => setEmail(e.target.value)}
                    value={email}
                  />
                  {error_Email && (
                    <span className="invalid_span">{error_Email}</span>
                  )}
                </FormGroup>
                <FormGroup className="set-bg-feild">
                <div style={{ position: 'relative' }}>
                  <Input
                    type={isPasswordVisible ? 'text' : 'password'}
                    name="password"
                    placeholder={
                      frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_password")
                          .length > 0
                          ? frontLabelsName.filter(
                            (e) => e.key == "lbl_password"
                          )[0]["value"] || "lbl_password"
                          : "lbl_password"
                        : "lbl_password"
                    }
                    errorValue={error_Password}
                    onChange={(e) => setPassword(e.target.value)}
                    value={password}
                  />
            <div
          onClick={togglePasswordVisibility}
          style={{
            position: 'absolute',
            right: '10px',
            top: '50%',
            transform: 'translateY(-50%)',
            cursor: 'pointer',
          }}
        >
          {isPasswordVisible ? <FaEye />: <FaEyeSlash />}
        </div>
      </div>
                  {error_Password && (
                    <span className="invalid_span">{error_Password}</span>
                  )}
                </FormGroup>
                <div className="set-position">
                  <Link className="text-left" to="/forget-password">
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_forget_password")
                        .length > 0
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_forget_password"
                        )[0]["value"] || "lbl_forget_password"
                        : "lbl_forget_password"
                      : "lbl_forget_password"}
                  </Link>
                </div>
                <div className="button-set mb-3">
                  <Button type="submit" onClick={onSubmit} disabled={loader}>
                    {loader ?  <BeatLoader color="#005da1" size="10" />  : frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_login").length >
                        0
                        ? frontLabelsName.filter((e) => e.key == "lbl_login")[0][
                        "value"
                        ] || "lbl_login"
                        : "lbl_login"
                      : "lbl_login"}
                  </Button>
                </div>
              </div>

              <div className="main-bottom-button d-flex">
                <Link to="/access-by-otp">
                  <Button >
                    {frontLabelsName
                      ? frontLabelsName.filter(
                        (e) => e.key == "lbl_login_with_phone"
                      ).length > 0
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_login_with_phone"
                        )[0]["value"] || "lbl_login_with_phone"
                        : "lbl_login_with_phone"
                      : "lbl_login_with_phone"}
                  </Button>
                </Link>
                <Link to="/dashboard">
                  <Button>
                    {frontLabelsName
                      ? frontLabelsName.filter(
                        (e) => e.key == "lbl_login_with_electronic"
                      ).length > 0
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_login_with_electronic"
                        )[0]["value"] || "lbl_login_with_electronic"
                        : "lbl_login_with_electronic"
                      : "lbl_login_with_electronic"}
                  </Button>
                </Link>
              </div>

              <div className="bottom-links text-center">
                <span>
                  {frontLabelsName
                    ? frontLabelsName.filter((e) => e.key == "lbl_not_with_access")
                      .length > 0
                      ? frontLabelsName.filter(
                        (e) => e.key == "lbl_not_with_access"
                      )[0]["value"] || "lbl_not_with_access"
                      : "lbl_not_with_access"
                    : "lbl_not_with_access"}{" "}
                  &nbsp;
                  <Link
                    to="/registration/type"
                    className="set-yellow"
                  >
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_registration")
                        .length > 0
                        ? frontLabelsName.filter(
                          (e) => e.key == "lbl_registration"
                        )[0]["value"] || "lbl_registration"
                        : "lbl_registration"
                      : "lbl_registration"}
                  </Link>
                </span>
              </div>
            </div>
          </Form>
        </div>
      </div>
      <Suspense fallback={<Loading />}>
        <Footer />
      </Suspense>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  label: state.language,
});

export default connect(mapStateToProps, {
  userLogin,
  loadUser,
})(Login);
